import {
  Component,
  AfterViewInit,
  OnDestroy,
  ViewChild,
  ElementRef,
  HostListener,
  Inject,
  PLATFORM_ID,
  Input,
  OnChanges
} from '@angular/core';
import { ChatServiceService } from '../../services/ChatService/chat-service.service';
import { CommonModule, isPlatformBrowser } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { trigger, transition, style, animate } from '@angular/animations';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faComments } from '@fortawesome/free-solid-svg-icons';

@Component({
  selector: 'app-chating',
  standalone: true,
  imports: [CommonModule, FormsModule, FontAwesomeModule],
  templateUrl: './chating.component.html',
  styleUrl: './chating.component.css',
  animations: [
    trigger('slidePanel', [
      transition(':enter', [
        style({ transform: 'translateX(100%)', opacity: 0 }),
        animate(
          '200ms ease-out',
          style({ transform: 'translateX(0)', opacity: 1 })
        ),
      ]),
      transition(':leave', [
        animate(
          '180ms ease-in',
          style({ transform: 'translateX(100%)', opacity: 0 })
        ),
      ]),
    ]),
  ],
})
export class ChatingComponent implements OnChanges, AfterViewInit, OnDestroy {
  @ViewChild('msgInput') msgInput!: { nativeElement: HTMLTextAreaElement };
  @ViewChild('video') videoRef!: ElementRef<HTMLVideoElement>;
  @ViewChild('canvas') canvasRef!: ElementRef<HTMLCanvasElement>;
  @ViewChild('chatContainer') private chatContainer!: ElementRef;
   @Input() chatData!: any;
   faComments = faComments;
  @Input() roomName!: string;
  opencameratab: any = 'none';
  activeInfoTab: 'media' | 'docs' | 'links' = 'media';
  activeUsersTab: 'all' | 'unread' | 'media' | 'video' = 'all';
// private autoScroll = true;
  autoScroll = true;
  atTop = true;
  maxInputHeight = 160; // px (WhatsApp-like cap)
  isSending = false;
  drImageBaseUrl = environment.baseUrl + '/MediaUploads/UserUpload/';
  senderId: any;
  userSessionId: any;
  receiverId: any;
  messages: any[] = [];
  newMessage = '';
  chatingList: any[] = [];
  filteredUsers: any[] = [];
  patientUserId: any;
  chat_room_id: any;
  senderName: any;
  chatMessages: any[] = [];
  extractedLinks: {
    url: string;
    text: string;
    fromId?: any;
    timestamp?: any;
  }[] = [];
  userStatus: any;
  selectedFileMsg: any = null;
  private static urlRegex = /(https?:\/\/|www\.)[^\s]+/gi;
  selectedUser: any;
  selectedFile: File | null = null;
  rightPanelOpen: boolean = false;
   chatPanelOpen: boolean = false;
  user_id: any;
  previewImageUrl: string | null = null;
  replyingTo: any = null;
  unreadCount: number = 0;
  statusUnsub: any;
  /*  selectedUserId: string = 'selectedUserId'; */ // Replace with actual user ID
  private messagesUnsub?: () => void;
  private unreadUnsub?: () => void;
  // private statusUnsub?: () => void;
  private unreadUnsubsByRoom: Record<string, () => void> = {};
  private lastMsgUnsubsByRoom: Record<string, () => void> = {};
  // userStatus: { online: boolean; lastSeen: Date | null } = { online: false, lastSeen: null };
  unsubscribe: any;
  constructor(
    private chat: ChatServiceService,
    private http: HttpClient,
    @Inject(PLATFORM_ID) private platformId: Object
  ) {
    let getHcpList = sessionStorage.getItem('userDetailsData');
    if (getHcpList) {
      this.patientUserId = JSON.parse(getHcpList).UserId;
      this.userSessionId = JSON.parse(getHcpList).SessionId;
      this.senderId = JSON.parse(getHcpList).UserId;
      this.senderName = JSON.parse(getHcpList).FirstName;
      console.log(this.patientUserId);

      // Initialize presence for current app user in RTDB

      this.http
        .get(
          `${environment.baseUrl}/mobilehcp/getHcpByPatientUserId?patientUserId=${this.patientUserId}`
        )
        .subscribe((data: any) => {
          this.chatingList = data?.data || [];
          this.applyUsersFilter();
          this.initUnreadCounters();
          console.log('Chat users:', this.chatingList);
          // this.chatingList.forEach((user: any) => {
          //   this.mapMessage(user.last_message).then((mappedLastMsg) => {
          //     user.last_message = mappedLastMsg;
          //   });
           
          // });

        });
    }
  }




  ngOnChanges() { 
  

    if (this.chatData) {
     
      console.log('Selected User Data:', this.chatData);
       this.selectUser(this.chatData);
    }
  }
  ngAfterViewInit() {
    setTimeout(() => this.scrollToBottom(), 0);
    if (!isPlatformBrowser(this.platformId)) return;
    queueMicrotask(() => {
      const el = this.msgInput?.nativeElement as HTMLTextAreaElement;
      if (el) this.autoResize(el);
    });
  }

  onEnter(e: any) {
    if (!e.shiftKey) {
      e.preventDefault();
      this.send();
    }
  }
  autoResize(el: HTMLTextAreaElement) {
    // Reset height then set to content height (capped)
    el.style.height = 'auto';
    const next = Math.min(el.scrollHeight, this.maxInputHeight);
    el.style.height = next + 'px';

    // Toggle scrollbar past cap
    if (el.scrollHeight > this.maxInputHeight) {
      el.classList.add('scrollable');
    } else {
      el.classList.remove('scrollable');
    }
  }
  groupMessagesByDate(messages: any[]) {
    const grouped: any[] = [];
    let lastDateLabel = '';

    messages.forEach((msg) => {
      const msgDate = this.normalizeDate(msg.timestamp || msg.createdAt);
      const today = new Date();
      const yesterday = new Date();
      yesterday.setDate(today.getDate() - 1);

      let dateLabel: string;
      if (msgDate.toDateString() === today.toDateString()) {
        dateLabel = 'Today';
      } else if (msgDate.toDateString() === yesterday.toDateString()) {
        dateLabel = 'Yesterday';
      } else {
        dateLabel = msgDate.toLocaleDateString(); // e.g. 9/1/2025
      }

      // Insert label only if it changed
      if (dateLabel !== lastDateLabel) {
        grouped.push({ isDateSeparator: true, label: dateLabel });
        lastDateLabel = dateLabel;
      }

      grouped.push({ ...msg, isDateSeparator: false });
    });

    return grouped;
  }

  normalizeDate(ts: any): Date {
    if (!ts) return new Date();
    if (ts instanceof Date) return ts;
    if (typeof ts.toDate === 'function') return ts.toDate();
    return new Date(ts);
  }

  // unsubscribe:any
  groupedMessages: any[] = [];
async mapMessage(msg: any): Promise<any> {
  const decrypted = await this.chat.decryptMessage(
    msg.message,
    msg.imageURL,
    this.chat_room_id
  );


  return {
    ...msg,
    message: decrypted.message,     // 🔓 decrypted text
    imageURL: decrypted.imageUrl,   // 🔓 decrypted image URL (if encrypted)
    timestamp:
  typeof msg.createdAt?.toDate === 'function'
    ? msg.createdAt.toDate()
    : msg.createdAt
  };
}


  selectUser(user: any) {
    // this.scrollToBottom1();
    // this.onScroll();
    // Handle user selection for chat
    console.log('Selected user:', user);
    // let objStartChat ={
    //   user_1_id: this.patientUserId,
    //   user_2_id: user.hcp_user_id ?? user.user_id

    // }
    // this.http.post(`${environment.baseUrl}/chat/start`, objStartChat).subscribe((data: any) => {
    //   console.log(data);
    //   sessionStorage.setItem('encryption_key_public', data.encryption.publicKey);
    //   sessionStorage.setItem('encryption_key_private', data.encryption.privateKey);
    //   sessionStorage.setItem('firebaseToken', data.firebaseToken);
    //   sessionStorage.setItem('usersPublicKeys_user1', data.usersPublicKeys.user1);
    //   sessionStorage.setItem('usersPublicKeys_user2', data.usersPublicKeys.user2);
    //  this.chat.loginWithToken(data.firebaseToken);
    //   // sessionStorage.setItem('usersPublicKeys_user2', data.usersPublicKeys[this.patientUserId]);
    // });
    // Unsubscribe previous listeners
    this.messagesUnsub?.();
    this.unreadUnsub?.();
    this.statusUnsub?.();
    if(this.chatData){
        this.selectedUser = user;
        console.log(this.selectedUser)
        console.log(this.selectedUser?.data?.tbl_hcp?.tbl_user?.first_name)
    this.chat_room_id = user.chatRoomId;
    this.user_id = user.DoctorUserId ?? user.DoctorUserId;
    this.receiverId = this.user_id;
    console.log(this.chat_room_id, this.user_id);
    }else{
      this.selectedUser = user;
        this.chat_room_id = user.chat_room_id;
        this.user_id = user.hcp_user_id ?? user.user_id;
        this.receiverId = this.user_id;
        console.log(this.chat_room_id, this.user_id);
    }
    // this.selectedUser = user;
    // this.chat_room_id = user.chat_room_id;
    // this.user_id = user.hcp_user_id ?? user.user_id;
    // this.receiverId = this.user_id;
    // console.log(this.chat_room_id, this.user_id);

this.messagesUnsub = this.chat.listenMessages(
  this.chat_room_id,
  this.patientUserId,
  (msgs, unreadCount) => {

    this.initUnreadCounters();

    Promise.all(msgs.map((msg) => this.mapMessage(msg)))
      .then((decryptedMsgs) => {

        // ✅ Update messages first
        this.chatMessages = decryptedMsgs;

        // ✅ Group messages
        this.groupedMessages = this.groupMessagesByDate(this.chatMessages);

        // ✅ Scroll
        this.scrollToBottom();

        // ✅ Update unread count
        this.unreadCount = unreadCount;

        // ✅ Extract links
        this.extractLinksFromMessages();

        // ✅ Mark messages as seen
        this.chat.markMessagesAsSeen(
          this.chat_room_id,
          this.patientUserId
        );

        // ✅ Update chat list last message
        const idx = (this.chatingList || []).findIndex(
          (u: any) => u.chat_room_id === this.chat_room_id
        );

        if (idx > -1) {
          if (this.chatMessages.length > 0) {
            const last = this.chatMessages[this.chatMessages.length - 1];

            const lastText =
              last.message ||
              (last.imageURL ? '📷 Image' : last.original_filename || 'File');

            let lastTime = last.timestamp || last.createdAt || new Date();
            if (lastTime?.toDate) {
              lastTime = lastTime.toDate();
            }

            this.chatingList[idx] = {
              ...this.chatingList[idx],
              unreadCount,
              last_message: lastText,
              lastMessage: lastText,
              last_message_time: lastTime,
              lastMessageTime: lastTime,
            };
          } else {
            // Handle cleared chat
            this.chatingList[idx] = {
              ...this.chatingList[idx],
              unreadCount: 0,
              last_message: '',
              lastMessage: '',
              last_message_time: null,
              lastMessageTime: null,
            };
          }

          this.applyUsersFilter();
        }
      })
      .catch(err => {
        console.error('Message mapping failed:', err);
      });
  }
);


    // this.messagesUnsub = this.chat.listenMessages(
    //   this.chat_room_id,
    //   this.patientUserId,
    //   (msgs, unreadCount) => {
    //     console.log('Messages:', msgs);
    //     this.initUnreadCounters();


    //     // Decrypt messages
    //     Promise.all(msgs.map((msg) => this.mapMessage(msg)))
    //     .then((decryptedMsgs) => {
    //       this.chatMessages = decryptedMsgs;
    //       console.log('Decrypted Messages:', this.chatMessages);
    //       this.groupedMessages = this.groupMessagesByDate(this.chatMessages);
    //       this.scrollToBottom();
    //       // this.unreadCount = unreadCount;
    //       console.log('Unread Count:', this.unreadCount);
    //     })
    //     .catch(err => {
    //       console.error('Message mapping failed:', err);
    //     });

    //     // this.chatMessages = msgs.map((msg) => ({
    //     //   ...msg,
    //     //   timestamp:
    //     //     msg.createdAt instanceof Timestamp
    //     //       ? msg.createdAt.toDate()
    //     //       : msg.createdAt,
    //     // }));
    //     this.groupedMessages = this.groupMessagesByDate(this.chatMessages);
    //     this.scrollToBottom();
    //     this.unreadCount = unreadCount;
    //     console.log('Unread Count:', this.unreadCount);

    //     // Extract links whenever messages update
    //     this.extractLinksFromMessages();
    //     console.log('Chat Messages:', this.chatMessages);

    //     // Mark messages as seen for current chat
    //     this.chat.markMessagesAsSeen(this.chat_room_id, this.patientUserId);

    //     // Update list item unread count and last message preview/time
    //     const idx = (this.chatingList || []).findIndex(
    //       (u: any) => u.chat_room_id === this.chat_room_id
    //     );
    //     if (idx > -1) {
    //       const last = this.chatMessages[this.chatMessages.length - 1];
    //       const lastText = last
    //         ? last.message ||
    //           (last.imageURL ? '📷 Image' : last.original_filename || 'File')
    //         : '';
    //       let lastTime: any = last
    //         ? last.timestamp || last.createdAt || new Date()
    //         : null;
    //       if (lastTime && typeof lastTime.toDate === 'function') {
    //         lastTime = lastTime.toDate();
    //       }

    //       this.chatingList[idx] = {
    //         ...this.chatingList[idx],
    //         unreadCount: unreadCount,
    //         last_message: lastText,
    //         lastMessage: lastText,
    //         last_message_time: lastTime,
    //         lastMessageTime: lastTime,
    //       };
    //       this.applyUsersFilter();
    //     }
    //   }

    // );

    // Presence for selected user
    /* this.statusUnsub = this.chat.listenUserStatus(
      this.user_id,
      (status: any) => {
        this.userStatus = status;
        console.log('User Status:', this.userStatus);
      }
    ); */
    /*  this.unsubscribe = this.chat.listenUserStatus(String(this.user_id));
    console.log("User status updated:", this.userStatus); */
    this.chat.listenUserStatus(
      String(this.user_id),
      (status: { online?: boolean; lastSeen?: any }) => {
        console.log('User status:', status);
        this.userStatus = {
          online: status.online,
          lastSeen: status.lastSeen,
        };
        // console.log("User status:", status.online, status.lastSeen?.toDate?.());
      }
    );

    // Live unread counter for this chat
    this.unreadUnsub = this.chat.listenUnreadCount(
      this.chat_room_id,
      this.patientUserId,
      (count: number) => {
        if (this.selectedUser) {
          this.selectedUser.unreadCount = count;
        }
        const idx = (this.chatingList || []).findIndex(
          (u: any) => u.chat_room_id === this.chat_room_id
        );
        if (idx > -1) {
          this.chatingList[idx] = {
            ...this.chatingList[idx],
            unreadCount: count,
          };
          this.applyUsersFilter();
        }
      }
    );
      setTimeout(() => this.scrolltoptobottom(), 0);
  }

  ngOnInit() {
    console.log('Chat Room ID:', this.chat_room_id);

    this.http.get(
    `${environment.baseUrl}/mobilehcp/getHcpByPatientUserId?patientUserId=${this.patientUserId}`
  )
  .subscribe((data: any) => {

    this.chatingList = data?.data || [];
    this.chat_room_id = this.chatingList[0]?.chat_room_id;

    this.messagesUnsub = this.chat.listenMessages(
      this.chat_room_id,
      this.patientUserId,
      (msgs: any[]) => {

        this.chatMessages = msgs;

        this.initUnreadCounters();

      }
    );

  });

    this.chat.setUserOnline(this.patientUserId);
    if (this.chat_room_id) {
      this.messagesUnsub = this.chat.listenMessages(
        this.chat_room_id,
        this.patientUserId,
        (msgs) => {
          this.chatMessages = msgs;
          this.extractLinksFromMessages();
          this.chat.markMessagesAsSeen(this.chat_room_id, this.patientUserId);
          console.log(this.chatMessages);
          this.initUnreadCounters();
        }
      );
    }

    this.chat.requestFcmToken().then((token) => {
      console.log('FCM Token:', token);
    });

    this.chat.listenPushNotifications((payload: any) => {
      console.log('Push Notification:', payload);
    });
  }

  isImageFile(url: string): boolean {
    const imageExtensions = ['.jpg', '.jpeg', '.png', '.gif', '.webp'];
    const lowerUrl = url.toLowerCase();
    return imageExtensions.some((ext) => lowerUrl.endsWith(ext));
  }
  filePreviewUrl: string | null = null;
  // onFileSelected(event: any) {
  //   const file = event.target.files[0];
  //   if (file) {
  //     this.selectedFile = file;

  //     // Preview only if image
  //     if (file.type.startsWith('image')) {
  //       const reader = new FileReader();
  //       reader.onload = (e: any) => {
  //         this.filePreviewUrl = e.target.result;
  //       };
  //       reader.readAsDataURL(file);
  //     } else {
  //       this.filePreviewUrl = null;
  //     }
  //   }
  // }
onFileSelected(event: any) {
  const file: File = event.target.files[0];
  if (!file) return;

  const maxSizeMB = 5;
  const fileSizeMB = file.size / (1024 * 1024);

  if (fileSizeMB > maxSizeMB) {
    alert('File size should not exceed 5MB');

    // Reset the file input so oversized video doesn't block typing
    event.target.value = ''; 
    this.selectedFile = null;
    this.filePreviewUrl = null;
    return;
  }

  this.selectedFile = file;

  // optional preview
  const reader = new FileReader();
  reader.onload = () => {
    this.filePreviewUrl = reader.result as string;
  };
  reader.readAsDataURL(file);
}
  removeSelectedFile() {
    this.selectedFile = null;
    this.filePreviewUrl = null;
  }
  opencameratab1: any = 'none';
  openImagePreview(message: any) {
    // Accept either a message object or a plain URL string
    const url = typeof message === 'string' ? message : message?.imageURL;
    this.previewImageUrl = url;
    // Preserve the selected message for timestamp display in modal header
    this.selectedFileMsg = typeof message === 'string' ? null : message;
    console.log('Opening image preview:', this.previewImageUrl);
    this.opencameratab1 = 'block';
  }
  closeImagePreview() {
    this.opencameratab1 = 'none';
    this.previewImageUrl = null;
  }

  replyToMessage(msg: any) {
    this.replyingTo = msg;
  }

  cancelReply() {
    this.replyingTo = null;
  }

//   async send() {
//     if (!this.newMessage.trim() && !this.selectedFile) return;
//     this.isSending = true;
//       const encrypted = await this.chat.encryptMessage(
//     this.newMessage,
//     this.chat_room_id
//   );


//     if (this.selectedFile) {
//       const formData = new FormData();
//       formData.append('files', this.selectedFile);

//       this.http
//         .post(`${environment.baseUrl}/chat/upload-multiple`, formData)
//         .subscribe((response: any) => {
//           if (!response?.files?.length) return;

//           const fileData = response.files[0];
//           const messagePayload: any = {
//             message: this.newMessage || '',
//             senderId: this.senderId,
//             receiverId: this.receiverId,
//             createdAt: new Date(),
//             senderName: this.senderName,
//             imageURL: `${environment.baseUrl}/${fileData.file_url}`,
//             file_type: fileData.file_type,
//             original_filename: fileData.original_filename,
//             seen: false,
//           };
//           // this.chat.encrypt(this.messages,sessionStorage.getItem('usersPublicKeys_user2')||'');  
         
//           console.log(messagePayload);
//           // 👉 Add reply info if replying
//           if (this.replyingTo) {
//             messagePayload.replySenderName = this.replyingTo.senderName;
//             messagePayload.replyToMessageText =
//               this.replyingTo.message ||
//               (this.replyingTo.imageURL
//                 ? '📷 Image'
//                 : this.replyingTo.original_filename || 'Fle');
//           }

//           this.chat.sendMessage(this.chat_room_id, messagePayload);
//               this.scrollToBottom();
//           // reset input
//           this.newMessage = '';
//           this.selectedFile = null;
//           this.filePreviewUrl = null;
//           this.replyingTo = null;

//           // reset textarea height
//           const el = this.msgInput?.nativeElement as HTMLTextAreaElement;
//           if (el) {
//             el.style.height = 'auto';
//             el.classList.remove('scrollable');
            
//           }

//           this.isSending = false;
//         });
//     } else {
    
//       const messagePayload: any = {
//         message: this.newMessage,
//         senderId: this.senderId,
//         receiverId: this.receiverId,
//         createdAt: new Date(),
//         senderName: this.senderName,
//         imageURL: null,
//         seen: false,
//       };
//       console.log(messagePayload);

//       // 👉 Add reply info if replying
//       /* if (this.replyingTo) {
//   messagePayload.replyTo = {
//     senderName: this.replyingTo.senderName,
//     message: this.replyingTo.message || 
//              (this.replyingTo.imageURL ? '📷 Image' : this.replyingTo.original_filename || 'File')
//   };
// } */
//       if (this.replyingTo) {
//         messagePayload.replySenderName = this.replyingTo.senderName;
//         messagePayload.replyToMessageText =
//           this.replyingTo.message ||
//           (this.replyingTo.imageURL
//             ? '📷 Image'
//             : this.replyingTo.original_filename || 'File');
//       }

//       this.chat.sendMessage(this.chat_room_id, messagePayload);

//       // reset input
//       this.newMessage = '';
//       this.replyingTo = null;

//       // reset textarea height
//       const el = this.msgInput?.nativeElement as HTMLTextAreaElement;
//       if (el) {
//         el.style.height = 'auto';
//         el.classList.remove('scrollable');
//       }

//       this.isSending = false;
//     }
//   }


async send() {
  if (!this.newMessage.trim() && !this.selectedFile) return;

  this.isSending = true;

  let encryptedMessage = '';

  // 🔐 Encrypt text if exists
  // if (this.newMessage.trim()) {
  //   encryptedMessage = await this.chat.encryptMessage(
  //     this.newMessage,
  //     this.chat_room_id
  //   );
  // }
const encrypted = await this.chat.encryptMessage(
  this.newMessage,
  null, // ⛔ image URL not available yet
  this.chat_room_id
);
  // 📎 FILE MESSAGE
  if (this.selectedFile) {
  const formData = new FormData();
  formData.append('files', this.selectedFile);

  this.http
    .post(`${environment.baseUrl}/chat/upload-multiple`, formData)
    .subscribe({
      next: async (response: any) => {
        if (!response?.files?.length) {
          this.isSending = false;
          return;
        }

        const fileData = response.files[0];
        const imageUrl = `${environment.baseUrl}/${fileData.file_url}`;

        // 🔐 Encrypt image URL (ONLY if you really want to)
        const encryptedImage = await this.chat.encryptMessage(
          null,
          imageUrl,
          this.chat_room_id
        );

        const messagePayload: any = {
          message: encrypted.message || '',         // 🔐 encrypted text
          imageURL: encryptedImage.imageUrl,        // 🔐 encrypted image URL
          senderId: this.senderId,
          receiverId: this.receiverId,
          createdAt: new Date(),
          senderName: this.senderName,
          file_type: fileData.file_type,
          original_filename: fileData.original_filename,
          seen: false,
        };

        // ↩️ Reply support (NO encryption here)
        if (this.replyingTo) {
          messagePayload.replySenderName = this.replyingTo.senderName;
          messagePayload.replyToMessageText =
            this.replyingTo.encrypted.message ||
            (this.replyingTo.imageURL
              ? '📷 Image'
              : this.replyingTo.original_filename || 'File');
        }

        await this.chat.sendMessage(this.chat_room_id, messagePayload);
        this.scrollToBottom();
        this.resetInputState();
      },
      error: () => (this.isSending = false),
    });
}
 else {
    // 💬 TEXT ONLY MESSAGE
    const messagePayload: any = {
      message: encrypted.message, // 🔐 ENCRYPTED
      senderId: this.senderId,
      receiverId: this.receiverId,
      createdAt: new Date(),
      senderName: this.senderName,
      imageURL: null,
      seen: false,
    };

    // ↩️ Reply support
    if (this.replyingTo) {
      messagePayload.replySenderName = this.replyingTo.senderName;
      messagePayload.replyToMessageText =
        this.replyingTo.message ||
        (this.replyingTo.imageURL
          ? '📷 Image'
          : this.replyingTo.original_filename || 'File');
    }

    this.chat.sendMessage(this.chat_room_id, messagePayload);
    this.http.post(`${environment.baseUrl}/chat/chat-notification`, {
      SessionId: this.userSessionId,
      reciverId: this.receiverId,
      messageText: this.newMessage,
      senderName: this.senderName,
      userType: 'HCP',

    }).subscribe(response => {
      console.log(response);
    });
    this.scrollToBottom();
    this.resetInputState();
  }
}
private resetInputState() {
  this.newMessage = '';
  this.selectedFile = null;
  this.filePreviewUrl = null;
  this.replyingTo = null;

  const el = this.msgInput?.nativeElement as HTMLTextAreaElement;
  if (el) {
    el.style.height = 'auto';
    el.classList.remove('scrollable');
  }

  this.isSending = false;
}


  deleteMessage(msg: any) {
    console.log('Deleting message:', msg);
    console.log(this.chat_room_id);
    msg.chatId = this.chat_room_id; // Ensure chatId is set
    this.chat.deleteMessage(msg);
  }
// async saveEdit(msg: any) {
//   try {
//     console.log('Editing message:', msg.message);

//     // Encrypt the edited message
//     const encrypted = await this.chat.encryptMessage(
//       msg.tempMessage,          // ✅ edited text
//       null,                 // no image
//       this.chat_room_id
//     );

//     let test= encrypted?.msg?.tempMessage;
//     // Prepare payload
//     const payload = {
//       message: test // or encrypted.message (based on your service)
//     };

//     // Send edited message
//     this.chat.editMessage(
//       this.chat_room_id,
//       msg.id,
//       payload
//     );

//   } catch (error) {
//     console.error('Error while editing message:', error);
//   }
// }

async saveEdit(msg: any): Promise<void> {
  try {
    const editedText = msg?.tempMessage?.trim();

    if (!editedText || !msg?.id) {
      console.warn('Invalid message data:', msg);
      return;
    }

    console.log('Editing message:', editedText);

    // Encrypt the edited message
    const encrypted = await this.chat.encryptMessage(
      editedText,        // ✅ edited text
      null,              // no image
      this.chat_room_id
    );

    if (!encrypted?.message) {
      throw new Error('Encryption failed');
    }

    // Prepare payload
    const payload = {
      message: encrypted.message // ✅ CORRECT
    };

    // Send edited message
    await this.chat.editMessage(
      this.chat_room_id,
      msg.id,
      payload
    );

    console.log('Message edited successfully');

  } catch (error) {
    console.error('Error while editing message:', error);
  }
}

  openSidepanel() {
    this.rightPanelOpen = true;

    // Switch to Docs if there are non-image files; otherwise stay on current
    const hasDocs = (this.chatMessages || []).some(
      (m: any) => m.imageURL && !this.isImageFile(m.imageURL)
    );
    if (hasDocs) this.activeInfoTab = 'media';
  }

  getMessageDate(msg: any): any {
    // createdAt may be Date | Timestamp | string
    const t = msg?.timestamp || msg?.createdAt;
    if (!t) return null;
    if (t instanceof Date) return t;
    if (typeof t?.toDate === 'function') return t.toDate();
    const d = new Date(t);
    return isNaN(d.getTime()) ? null : d;
  }

  getUserLastTime(user: any): Date | null {
    // Handles Date | Firestore Timestamp | ISO/string
    const t = user?.last_message_time ?? user?.lastMessageTime;
    if (!t) return null;
    if (t instanceof Date) return t;
    if (typeof t?.toDate === 'function') return t.toDate();
    const d = new Date(t);
    return isNaN(d.getTime()) ? null : d;
  }
  closeRightPanel() {
    this.rightPanelOpen = false;
  }

  // Header menu
  headerMenuOpen = false;
  attachMenuOpen = false;
  toggleHeaderMenu(e?: MouseEvent) {
    if (e) e.stopPropagation();
    this.headerMenuOpen = !this.headerMenuOpen;
  }

  toggleAttachMenu(e?: MouseEvent) {
    if (e) e.stopPropagation();
    this.attachMenuOpen = !this.attachMenuOpen;
  }
  clearAllChat() {
    if (!this.chat_room_id) return;
    this.chat.clearAllMessages(this.chat_room_id);
    this.chatMessages = [];
    this.groupedMessages = [];
    this.headerMenuOpen = false;
    //  this.selectUser(this.chat_room_id);
    // location.reload();
  }

  copyMessage(text: string) {
    if (!text) return;

    // Modern way
    navigator.clipboard
      .writeText(text)
      .then(() => {
        console.log('Message copied:', text);
        // Optional: show a toast/snackbar
      })
      .catch((err) => {
        console.error('Failed to copy:', err);
        // Fallback for old browsers
        const textarea = document.createElement('textarea');
        textarea.value = text;
        document.body.appendChild(textarea);
        textarea.select();
        document.execCommand('copy');
        document.body.removeChild(textarea);
      });
  }
@HostListener('document:click', ['$event'])
onDocumentClick(event: MouseEvent) {
  const target = event.target as HTMLElement;

  // Only update if there are menus open to avoid unnecessary re-renders
  const hasOpenMenus = this.groupedMessages.some((m: any) => m.showMenu);

  if (!target.closest('.menu-wrapper') && hasOpenMenus) {
    this.groupedMessages = this.groupedMessages.map((m: any) =>
      m.showMenu ? { ...m, showMenu: false } : m
    );
  }

  if (!target.closest('.header-menu-wrapper') && this.headerMenuOpen) {
    this.headerMenuOpen = false;
  }

  if (!target.closest('.attach-wrapper') && this.attachMenuOpen) {
    this.attachMenuOpen = false;
  }
}

  // Close any open message menus when clicking outside
  // @HostListener('document:click', ['$event'])
  // onDocumentClick(event: MouseEvent) {
  //   // Close menus only if clicking outside any .menu-wrapper, header or attach area
  //   const target = event.target as HTMLElement;
  //   if (!target.closest('.menu-wrapper')) {
  //     this.chatMessages = this.chatMessages.map((m) => ({
  //       ...m,
  //       showMenu: false,
  //     }));
  //   }
  //   if (!target.closest('.header-menu-wrapper')) {
  //     this.headerMenuOpen = false;
  //   }
  //   if (!target.closest('.attach-wrapper')) {
  //     this.attachMenuOpen = false;
  //   }
  // }

  setInfoTab(tab: 'media' | 'docs' | 'links') {
    this.activeInfoTab = tab;
  }

get docs() {
  return (this.chatMessages || []).filter(
    (msg: any) => msg.imageURL && !this.isImageFile(msg.imageURL)
  );
}

get media() {
  return (this.chatMessages || []).filter(
    (msg: any) =>
      msg.imageURL &&
      (this.isImageFile(msg.imageURL) || this.isVideoFile(msg.imageURL))
  );
}

private extractLinksFromMessages() {
  const urlRegex =
    /(https?:\/\/[^\s]+|www\.[^\s]+|[a-zA-Z0-9.-]+\.[a-z]{2,}(\/\S*)?)/gi;

  const imageExtensions = ['.png', '.jpg', '.jpeg', '.gif', '.webp'];

  const links: {
    url: string;
    text: string;
    fromId?: any;
    timestamp?: any;
    isImage?: boolean;
  }[] = [];

  (this.chatMessages || []).forEach((m: any) => {
    const text = (m?.message || '').toString();
    if (!text) return;

    const matches = text.match(urlRegex) || [];
    matches.forEach((raw: string) => {
      let url = raw.startsWith('http') ? raw : `https://${raw}`;

      // fix spaces in filename like "image (7).png"
      url = url.replace(/\s/g, '%20');

      const isImage = imageExtensions.some(ext =>
        url.toLowerCase().endsWith(ext)
      );

      links.push({
        url,
        text: raw,
        fromId: m.senderId,
        timestamp: m.timestamp,
        isImage,
      });
    });
  });

  // ✅ de-duplicate
  const seen = new Set<string>();
  this.extractedLinks = links.filter((l, i) => {
    const ts = l.timestamp ? new Date(l.timestamp).getTime() : i;
    const key = `${l.url}|${ts}`;
    if (seen.has(key)) return false;
    seen.add(key);
    return true;
  });

  console.log('Extracted links:', this.extractedLinks);
}

/**
 * Downloads a document from the provided message object
 * @param msg - The message object containing document information
 */
  downloadDoc(msg: any) {
    if (!msg?.imageURL) return;
    // Avoid SSR errors
    if (!isPlatformBrowser(this.platformId)) {
      return;
    }
    const a = document.createElement('a');
    a.href = msg.imageURL;
    a.target = '_blank';
    a.download = msg.original_filename || 'file';
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  }

  setUsersTab(tab: 'all' | 'unread' | 'media' | 'video') {
    this.activeUsersTab = tab;
    this.applyUsersFilter();
  }

  private async decryptLastMessageForList(last: any, roomId: string): Promise<string> {
  if (!last) return '';

  try {
    const decrypted = await this.chat.decryptMessage(
      last.message || null,
      last.imageURL || null,
      roomId
    );

    if (decrypted?.message) return decrypted.message;
    if (decrypted?.imageUrl) return '📷 Image';
    if (last.original_filename) return last.original_filename;

    return '';
  } catch (err) {
    console.error('Last message decrypt failed', err);
    return '🔒 Encrypted message';
  }
}


  // private applyUsersFilter() {
  //   if (this.activeUsersTab === 'unread') {
  //     // Expect each user item may have unreadCount or lastMessageSeen flag; fallback to 0
  //     this.filteredUsers = (this.chatingList || []).filter((u) => {
       
  //       const count = (u.unreadCount ??
  //         u.unread_count ??
  //         u.UnreadCount ??
  //         0) as number;
  //       return count > 0;
  //     });
  //   } else {
  //     this.filteredUsers = [...(this.chatingList || [])];
  //   }
  // }
  private applyUsersFilter() {
  let users = [...(this.chatingList || [])];

  // 1️⃣ Filter unread users if tab is "unread"
  if (this.activeUsersTab === 'unread') {
    users = users.filter((u) => {
      const count =
        u.unreadCount ??
        u.unread_count ??
        u.UnreadCount ??
        0;

      return Number(count) > 0;
    });
  }

  // 2️⃣ Sort by last_message_time (latest first)
  users.sort((a: any, b: any) => {
    const timeA = a.last_message_time
      ? new Date(a.last_message_time).getTime()
      : 0;

    const timeB = b.last_message_time
      ? new Date(b.last_message_time).getTime()
      : 0;

    return timeB - timeA; // newest chat on top
  });

  // 3️⃣ Assign to filtered list
  this.filteredUsers = users;
}


  private initUnreadCounters() {
    // Clear existing
    let totalunreadMessages = 0;
    Object.values(this.unreadUnsubsByRoom).forEach((fn) => fn?.());
    console.log('Cleared unread subscriptions', this.unreadUnsubsByRoom);
    Object.values(this.lastMsgUnsubsByRoom).forEach((fn) => fn?.());
    this.unreadUnsubsByRoom = {};
    this.lastMsgUnsubsByRoom = {};

    (this.chatingList || []).forEach((u: any) => {
      const roomId = u.chat_room_id;
      if (!roomId) return;

      // Unread counts
      this.unreadUnsubsByRoom[roomId] = this.chat.listenUnreadCount(
        roomId,
        this.patientUserId,
        (count: number) => {
          u.unreadCount = count;
          console.log(`Updated unread count for ${roomId}:`, count);
          const totalUnread = (this.chatingList || []).reduce(
            (sum: number, usr: any) => sum + (usr.unreadCount || 0),
            0
          );
          totalunreadMessages = totalUnread; // store in a class property
          this.chat.updateTotalUnread(totalunreadMessages);
          console.log('Total unread messages:', totalunreadMessages);
          if (this.activeUsersTab === 'unread') this.applyUsersFilter();
        }
      );

      // Latest message preview and time
      this.lastMsgUnsubsByRoom[roomId] = this.chat.listenLatestMessage(
  roomId,
  async (last: any | null) => {
    if (!last) {
      u.last_message = '';
      u.lastMessage = '';
      u.last_message_time = null;
      u.lastMessageTime = null;
      this.applyUsersFilter();
      return;
    }

    const lastText = await this.decryptLastMessageForList(last, roomId);

    let lastTime: any = last.createdAt || last.timestamp || new Date();
    if (lastTime && typeof lastTime.toDate === 'function') {
      lastTime = lastTime.toDate();
    }

    u.last_message = lastText;
    u.lastMessage = lastText;
    u.last_message_time = lastTime;
    u.lastMessageTime = lastTime;

    this.applyUsersFilter(); // refresh UI
  }
);

    
    });
  }
  async openCamera() {
    this.opencameratab = 'block';
    const video = this.videoRef.nativeElement;
    try {
      const stream = await navigator.mediaDevices.getUserMedia({ video: true });
      video.srcObject = stream;

      // Open modal (Bootstrap)
      /*  const modal = new (window as any).bootstrap.Modal(document.getElementById('cameraModal')!);
    modal.show() */
    } catch (err) {
      console.error('Camera access denied:', err);
      // fallback → open file picker if webcam not available
      (document.getElementById('imageInput') as HTMLInputElement)?.click();
    }
  }

  capturePhoto() {
    const video = this.videoRef.nativeElement;
    const canvas = this.canvasRef.nativeElement;

    canvas.width = video.videoWidth;
    canvas.height = video.videoHeight;

    const ctx = canvas.getContext('2d')!;
    ctx.drawImage(video, 0, 0, canvas.width, canvas.height);

    canvas.toBlob((blob) => {
      if (blob) {
        this.selectedFile = new File([blob], 'captured-image.png', {
          type: 'image/png',
        });
        this.filePreviewUrl = URL.createObjectURL(blob);
        this.opencameratab = 'none';
        // stop camera
        const stream = video.srcObject as MediaStream;
        stream.getTracks().forEach((track) => track.stop());

        // close modal
        const modal = (window as any).bootstrap.Modal.getInstance(
          document.getElementById('cameraModal')!
        );
        modal?.hide();
        this.opencameratab = 'none';
      }
    }, 'image/png');
  }
  hideCameraModal() {
    this.opencameratab = 'none';
    const video = this.videoRef.nativeElement;
    const stream = video.srcObject as MediaStream;
    if (stream) {
      stream.getTracks().forEach((track) => track.stop());
      video.srcObject = null;
    }
  }
  isVideoFile(url: string): boolean {
    const videoExtensions = ['.mp4', '.webm', '.ogg', '.mov', '.avi', '.mkv'];
    const lowerUrl = url.toLowerCase();
    return videoExtensions.some((ext) => lowerUrl.endsWith(ext));
  }
  openVideoPreview(url: string) {
    // open modal or new tab
    window.open(url, '_blank');
  }
  ngOnDestroy() {
    this.messagesUnsub?.();
    this.unreadUnsub?.();
    this.statusUnsub?.();
    Object.values(this.unreadUnsubsByRoom).forEach((fn) => fn?.());
    this.chat.setUserOffline(this.patientUserId);
  }
downloadFile() {
  if (!this.previewImageUrl) return;

  fetch(this.previewImageUrl)
    .then(res => res.blob())
    .then(blob => {
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = 'image.png';
      a.click();
      window.URL.revokeObjectURL(url);
    })
}


  // Share function (Web Share API)
shareContent() {
  if (!this.previewImageUrl) {
    return;
  }

  if (navigator.share) {
    navigator.share({
      title: 'Check this Image!',
      text: 'Take a look at this image:',
      url: this.previewImageUrl // now guaranteed to be string
    })
  } else {
  }

}

  // Copy text function
 
 copyText() {
    if (!this.previewImageUrl) {
      return;
    }

    navigator.clipboard.writeText(this.previewImageUrl)
      .then(() => {
      })
      .catch(() => {
      });
  }
onImageError(user: any) {
  user.image = null; // force Angular to hide the <img> and show initials
}

getInitials(name: string): string {
  if (!name) return '';
  const parts = name.trim().split(' ');
  if (parts.length === 1) {
    return parts[0].charAt(0).toUpperCase();
  }
  return (
    parts[0].charAt(0).toUpperCase() +
    parts[parts.length - 1].charAt(0).toUpperCase()
  );
}
onScroll(): void {
  if (!this.chatContainer) return;

  const chat = this.chatContainer.nativeElement;
  const distanceFromBottom =
    chat.scrollHeight - chat.scrollTop - chat.clientHeight;

  // 30px buffer feels natural
  this.autoScroll = distanceFromBottom < 30;
}

onNewMessage(): void {
    if (this.autoScroll) {
      this.scrollToBottom();
    }
  }
private scrollToBottom(): void {
  if (!this.chatContainer) return;

  setTimeout(() => {
    const chat = this.chatContainer.nativeElement;
    chat.scrollTop = chat.scrollHeight;
  }, 0);
}
scrollToBottom1(): void {
  if (!this.chatContainer) return;
  const chat = this.chatContainer.nativeElement;
  console.log('scrollToBottom1 called'+chat.scrollHeight);
  chat.scrollTop = chat.scrollHeight;
  this.autoScroll = true;
}
 scrolltoptobottom(): void {
   if (!this.chatContainer) return;

  const el = this.chatContainer.nativeElement;

  el.scrollTo({
    top: el.scrollHeight,
    behavior: 'smooth'
  });
  }
  onUserItemClick(event: MouseEvent, user: any): void {
  event.stopPropagation(); // 🔥 IMPORTANT

  this.selectUser(user);

  // wait for messages + DOM render
  setTimeout(() => {
    this.scrolltoptobottom();
  }, 100);
}

// Call this only when new messages are added
// ngAfterViewChecked() {
//   this.scrollToBottom();
// }

  trackByMsgId(index: number, item: any): any {
    return item.id || item.timestamp || item.label || index;
  }
}